<template>
  <div>
    <NamiButton buttonType="danger" text @click="$emit('reset')">
      Reset
    </NamiButton>
    <NamiButton buttonType="primary" text @click="$emit('done')">
      Done
    </NamiButton>
  </div>
</template>

<script setup lang="ts">
defineEmits<{
  (e: "reset"): void;
  (e: "done"): void;
}>();
</script>
